// ======================================================================
// File Name       : ContentEachQuestionAttributeList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Col, Button, Table, Modal, Form } from 'react-bootstrap';
import { MODAL_SIZE } from '../../constants/index';

class ContentEachQuestionAttributeList extends React.Component {
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const eachQuestionAttributeView = this.props.eachQuestionAttributeList
      ? this.props.eachQuestionAttributeList.map((eachQuestionAttribute, index) =>
        (<tr key={index}>
          <th>
            {eachQuestionAttribute.eachQuestionAttributeId}
          </th>
          <th>
            {eachQuestionAttribute.eachQuestionAttributeName}
          </th>
        </tr>),
        )
      : null;
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.md}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            個別属性
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="padding-10">
          <Col sm={12}>
            <Form.Group className="margin-top-10">
              <Table striped hover>
                <thead>
                  <tr>
                    <th>個別属性ID</th>
                    <th>属性名</th>
                  </tr>
                </thead>
                <tbody>
                  {eachQuestionAttributeView}
                </tbody>
              </Table>
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="primary" className="btn-96 margin-10" onClick={this.props.onCancel}>
            戻る
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ContentEachQuestionAttributeList;
